// ----------------------------------------------------------------------
// <copyright file="Izenda.SystemVariablesAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var compose = require('recompose').compose;
  var PropTypes = require('react').PropTypes;
  var withHandlers = require('recompose').withHandlers;
  var setPropTypes = require('recompose').setPropTypes;
  var lifecycle = require('recompose').lifecycle;
  const { curry } = require('lodash/fp');

  var systemVariablesAction = compose(
    setPropTypes({
      store: PropTypes.object.isRequired,
      onSelect: PropTypes.func
    }),
    lifecycle({
      componentDidMount: function() {
        var props = this.props;
        var loader = props.loader;

        props.loader.startLoading();
        props.store.fetchSystemVariables().then(loader.endLoading.bind(loader));
      },
      componentWillUnmount: function() {
        this.props.store.systemVariables.resetPageModel();
      }
    }),
    withHandlers({
      onSortChange: curry(onSortChange),
      onSelect: curry(onSelect)
    })
  );

  /**
   * Handle sort change.
   * @param  {Object} props
   * @param  {String} columnKey
   * @param  {String} sortDir
   */
  function onSortChange(props, columnKey, sortDir) {
    props.store.sortSystemVariables(columnKey, sortDir);
  }

  /**
   * Handle on select.
   * @param  {Object} props
   * @param  {Object} detail
   */
  function onSelect(props, detail) {
    props.onSelect && props.onSelect(detail.name);
  }

  module.exports = systemVariablesAction;
})();



// WEBPACK FOOTER //
// ./ui/modules/Subscription/Izenda.SystemVariablesAction.js